import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import RedeemIcon from '@mui/icons-material/Redeem'
import { Alert, Button, Grid, Typography /* Fade */ } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React /* , { useContext, useState } */ from 'react'

const AddPerkBanner = () => {
  const theme = useTheme()
  // setting to open permanently. there will be a followup ticket to add the 'hide' functionality without reseting on every select
  // const [open, setOpen] = useState(true)

  // Simplified: always show the banner for now
  // if (!user?.isCEO) return null
  return (
    <Alert
      iconMapping={{
        success: <RedeemIcon sx={{ color: theme.palette.accentGreen[500] }} />,
      }}
      sx={{
        border: `1px solid ${theme.palette.accentGreen.main}`,
        '& .MuiAlert-message': {
          width: '100%',
          overflowX: 'hidden',
        },
      }}
    >
      <Grid container display="flex" flexDirection="row">
        <Grid
          container
          item
          flexDirection={'column'}
          xs={9}
          md={10}
          sx={{ paddingRight: '15px' }}
        >
          <Grid item>
            <Typography
              variant="body1"
              fontWeight="500"
              color={theme.palette.accentGreen.dark}
            >
              Add Your Company As A Perk Provider
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2" color={theme.palette.accentGreen.dark}>
              Grow your business while helping other Techstars founders save
              money and extend their runway.
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={3} md={2}>
          <Button
            href="/perks/s"
            target="_blank"
            size="small"
            variant="text"
            endIcon={
              <OpenInNewIcon sx={{ color: theme.palette.accentGreen.dark }} />
            }
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              color: theme.palette.accentGreen.dark,
              height: { xs: 'auto' },
              padding: 0,
            }}
          >
            Request to Add Perk
          </Button>
        </Grid>
      </Grid>
    </Alert>
  )
}

export default AddPerkBanner
